import Redux = require("redux");
import {iConfig} from "./interfaces";

export const DUMMY = 'dummy action';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_YEAR = 'SET_YEAR';
export const SET_QUARTER = 'SET_QUARTER';
export const SET_PERIOD = 'SET_PERIOD';
export const SET_METRIC = 'SET_METRIC';

export interface iSetConfig extends Redux.Action{
    config: iConfig;
}

export interface iSetYear extends Redux.Action{
    year: number;
}

export interface iSetQuarter extends Redux.Action{
    quarter: number;
}

export interface iSetPeriod extends Redux.Action{
    period: string;
}

export interface iSetMetric extends Redux.Action{
    metric: string;
}